import React from 'react';
import styles from './Story.scss';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import Refresh from '../Refresh/Refresh';
import { useTranslation } from 'react-i18next';

const StorySkeleton: React.FunctionComponent<SkeletonProps> = ({
  animated,
  onRefresh,
  displayRefreshButton,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Refresh
      onRefresh={onRefresh}
      displayRefreshButton={displayRefreshButton}
      buttonLabel={t('story.refresh')}
    >
      <div className={styles.story}>
        <PlaceholderBar width="20%" height={24} animated={animated} />
        <PlaceholderBar width="90%" animated={animated} />
        <PlaceholderBar width="100%" animated={animated} />
        <PlaceholderBar width="80%" animated={animated} />
        <PlaceholderBar width="60%" animated={animated} />
      </div>
    </Refresh>
  );
};

export default StorySkeleton;
